<template>
  <section class="leftAsideElMainFrom">
    <section class="leftAsideElMainSe">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" />
    </section>
  </section>
</template>
<script>
export default {
  props: {},
  data() {
    return {
      menuData: [],
      muneTitle: "",
      redirectMenu: {}
    };
  },
  watch: {
    $route(to, from) {
      const toArr = to.path.split("/");
      const fromArr = from.path.split("/");
      if (toArr[2] != fromArr[2]) {
        this.getMenuData();
      }
    }
  },
  async mounted() {},
  methods: {
    // 获取左菜单数据
    getMenuData() {
      if (!this.$route.meta.showLeftAside) {
        return;
      }
      this.menuData = [];
      let allRouter = this.$router.options.routes;
      let matched = this.$route.matched;

      let path1 = matched[0].path;
      let path2 = matched[1].path;
      let path1Arr = [];
      allRouter.forEach(element => {
        if (element.path === path1) {
          path1Arr = element.children;
        }
      });
      path1Arr.forEach(element => {
        if (element.path === path2) {
          this.menuData = element.children;
          this.muneTitle = (element.meta && element.meta.menuName) || "";
        }
      });
      console.log(this.menuData, this.muneTitle);
      // 权限过滤，待实现,vuex保存对应的数据
      // {}

      // 未指定页面时，访问菜单第一个有权限的页面
      if (this.$route.path.split("/").length == 3) {
        for (let i = 0; i < this.menuData.length; i++) {
          if (
            !this.menuData[i].children ||
            this.menuData[i].children.length == 0
          ) {
            // 记录第一个有权限的菜单
            this.redirectMenu = this.menuData[i];
            break;
          }
        }
        this.$router.push({
          path: this.redirectMenu.path
        });
      }
    }
  },
  created() {
    this.getMenuData();
  }
};
</script>
<style lang="less" scope>
.leftAsideElMainFrom {
  width: 100%;
  height: 100%;
  background: #ffffff;
  display: flex;
  .leftAsideElMainSe {
    width: 100%;
    height: 100%;
  }
}
</style>
